"use client";

import { AuthUiProvider } from "@/components/auth-ui-provider";
import { Link } from "@/lib/navigation";
import { AuthCard } from "@repo/auth-ui";

import { BrandPanel } from "./brand-panel";

const FORM_CLASS_NAMES = {
  base: "border-0 bg-transparent p-0 shadow-none",
  title: "text-2xl font-semibold tracking-tight",
  description: "text-muted-foreground",
  footerLink: "font-medium text-foreground underline-offset-4 hover:underline",
} as const;

export default function AuthViewClient({ pathname }: { readonly pathname: string }) {
  return (
    <div className="grid min-h-[100dvh] lg:grid-cols-[1.05fr_1fr]">
      <BrandPanel pathname={pathname} />
      <main className="flex flex-col items-center justify-center px-6 py-12 sm:px-10">
        <div className="w-full max-w-sm">
          <MobileBrand />
          <AuthUiProvider>
            <AuthCard bare classNames={FORM_CLASS_NAMES} pathname={pathname} />
          </AuthUiProvider>
        </div>
      </main>
    </div>
  );
}

// Compact branding for small screens, where the split-panel BrandPanel is
// hidden. Keeps the form anchored to the product instead of floating bare.
function MobileBrand() {
  return (
    <Link
      className="mb-8 flex w-fit items-center gap-2 font-mono text-xs lowercase tracking-[0.04em] text-muted-foreground transition-colors hover:text-foreground lg:hidden"
      href="/"
    >
      <span className="size-1.5 rounded-full bg-violet-500" />
      albertonline.org
    </Link>
  );
}
